import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import {Constants} from '../constants';

declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;
declare var event: any;

@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.css']
})
export class BillingComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
 nao = new Nanobar();
  invoiceData: any;
  invoiceDetailData: any;
  invoiceDetailDatainner: any;
  invoiceDetailDataOrder: any;
  address: any;
  paymentBtn = false;
  incoiceNo: any;
  paymentMethod = 1;
  paymentAmount = '';
  addPaymentData: any;
  printPopOpen = false;
  invoiceStatus: any;
  searchInvoice = '';
  clearTimeout: any;
  paginatedDataInvoices: any;
  invoicePageCount = 0;
  invoiceLastPage = true;
  constructor(private dataService: DataService) { }
   getInvoices() {
    this.invoicePageCount = 0;
    this.nao.go(30);
    this.dataService.getInvoicesList(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.invoiceData = data;
        this.invoiceLastPage = this.invoiceData.last_page;
        this.invoicePageCount++;
        this.invoiceData = this.invoiceData.items;
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }
  getInvoicesByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getInvoicesListbyPage(window.localStorage.getItem('token'), this.invoicePageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataInvoices = data;
        // this.limit = this.paginatedData.limit;
        this.invoiceLastPage = this.paginatedDataInvoices.last_page;
        this.invoicePageCount++;
        this.paginatedDataInvoices = this.paginatedDataInvoices.items;
        for (var i = 0; i < this.paginatedDataInvoices.length; i++) {
          this.invoiceData.push(this.paginatedDataInvoices[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  invoiceDetail(id) {
    this.nao.go(30);
    this.dataService.getInvoiceDetail(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        this.nao.go(100);
        this.invoiceDetailData = data;
        this.invoiceDetailData = this.invoiceDetailData.invoice_detail;
        this.address = this.invoiceDetailData.address;
        this.invoiceDetailDatainner = this.invoiceDetailData.invoice_detail;
        console.log('this.invoiceDetailDatainner', this.invoiceDetailDatainner);
        this.invoiceDetailDataOrder = this.invoiceDetailDatainner.order_list;
        $('#invoicePop').modal('show');
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }
  showAddPaymentBtn(index, incoiceNo, status){
    this.invoiceStatus = status;
    console.log(index);
    this.incoiceNo = incoiceNo;
    if ( $('#chk' + index).prop('checked') === false ) {
      var checked = true;
    } else {
      checked = false;
    }
    $('#target input').prop('checked', false);
    if ( checked === true ) {
      $('#chk' + index).prop('checked', false);
      this.paymentBtn = false;
      console.log('paymentBtn', this.paymentBtn);
    }
    if ( checked === false ) {
      $('#chk' + index).prop('checked', true);
      this.paymentBtn = true;
      console.log('paymentBtn', this.paymentBtn);
    }
  }
  showAddPaymentPopup() {
    this.paymentAmount = '';
    $('#addAmountPop').modal('show');
  }
  getPaymentMode(value) {
    if ( value === '1' ) {
      this.paymentMethod = 1;
    }
    if ( value === '2' ) {
      this.paymentMethod = 2;
    }
  }
  SubmitAddPayment(){
    this.nao.go(30);
    this.dataService.addPayment(window.localStorage.getItem('token'), this.paymentMethod, this.paymentAmount, this.incoiceNo).subscribe(
      (data) => {
        this.nao.go(100);
        this.addPaymentData = data;
        $('#target input').prop('checked', false);
        this.paymentBtn = false;
        if (this.addPaymentData.success === true) {
          toastr.success(this.addPaymentData.message);
          this.getInvoices();
        }
        if (this.addPaymentData.success === false) {
          toastr.error(this.addPaymentData.message);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getDataPrintinvoice() {
    this.nao.go(30);
    this.dataService.getInvoiceDetail(window.localStorage.getItem('token'), this.incoiceNo).subscribe(
      (data) => {
        this.nao.go(100);
        this.invoiceDetailData = data;
        this.invoiceDetailData = this.invoiceDetailData.invoice_detail;
        this.address = this.invoiceDetailData.address;
        this.invoiceDetailDatainner = this.invoiceDetailData.invoice_detail;
        console.log('this.invoiceDetailDatainner', this.invoiceDetailDatainner);
        this.invoiceDetailDataOrder = this.invoiceDetailDatainner.order_list;
      },
      (error) => {
        this.nao.go(100);
        toastr.error('Some thing went wrong');
      }
    );
  }
  openprintInvoicePop(){
    var context = this;
    let printContents, popupWin;
    context.printPopOpen = true;
    // const configuracion_ventana = 'menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes';
    // 'height=400,width=800'
    setTimeout(() => {
      printContents = document.getElementById('printIncoive');
      // var oldPage = document.body.innerHTML;
      popupWin = window.open('package pdrop_pinop', '', 'height=400,width=800');
      popupWin.document.open();
      popupWin.document.write('<html><body onload="window.print()">' + printContents.innerHTML + '</body></html>');
      popupWin.document.close();
      // popupWin.close();
      // context.printPopOpen = false;
    }, 1000);
    setTimeout(function() {
      popupWin.close();
      context.printPopOpen = false;
    }, 1500);
  }
  clearSearch() {
    this.searchInvoice = '';
    this.filterSearch();
  }
  filterSearch() {
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    this.invoicePageCount = 0;
    this.nao.go(30);
    console.log('login data');
    this.dataService.searchInvoicesList(window.localStorage.getItem('token'), this.searchInvoice).subscribe(
      (data) => {
        this.nao.go(100);
        this.invoiceData = data;
        this.invoiceLastPage = this.invoiceData.last_page;
        this.invoicePageCount++;
        this.invoiceData = this.invoiceData.items;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
  ngOnInit() {
    this.getInvoices();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#billing').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/app/billing/billing.component.ts